import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
  private static readonly UNITS = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

  transform(bytes: number | null | undefined, decimals = 1): string {
    if (bytes == null || bytes === 0) {
      return '0 Bytes';
    }

    const k = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const unitIndex = Math.min(i, FileSizePipe.UNITS.length - 1);
    const value = bytes / Math.pow(k, unitIndex);

    return `${parseFloat(value.toFixed(decimals)).toString().replace('.', ',')} ${FileSizePipe.UNITS[unitIndex]}`;
  }
}
